import { AccordionContent, AccordionItem, AccordionTrigger } from "@/shared/components/ui/accordion";
import React, { ReactNode } from "react";

const FaqItem = ({ question, answer }: { question: string; answer: ReactNode }) => {
    return (
        <AccordionItem value={question}>
            <div className="border-b border-stroke-secondary">
                <AccordionTrigger tabIndex={0} className="py-4 text-left text-base font-bold text-content-primary">
                    {question}
                </AccordionTrigger>
                <AccordionContent className="mt-1 pb-4 text-content-secondary">{answer}</AccordionContent>
            </div>
        </AccordionItem>
    );
};

export default FaqItem;
